import styles from './Footer.module.css';
import { useNavigate } from 'react-router-dom';
import { bottomNav } from '../../../data/landingPageHelpers';
import { routesLinks } from '../../../utils/RouteConstants';

const LOGO_WHITE = '/assets/logo-white.svg';
const ARROW_ICON = '/assets/arrow-down.svg';

export default function Footer() {
  const navigate = useNavigate();

  const handleNavigate = (path, isRoute, externalPath) => {
    if (isRoute) {
      if (path === "/") {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        window.scrollTo(0, 0);

        const mobileScrollContainer = document.querySelector('.mobile-inner-scroll');
        if (mobileScrollContainer) {
          mobileScrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
        }
      } else {
        navigate(path);
      }
    } else {
      window.open(externalPath, "_blank", "noopener,noreferrer");
    }
  };
  return (
    <footer id="footer" className={styles.footer} role="contentinfo">
      <div className={styles.inner}>

        {/* ── Logo ───────────────────────────────────────── */}
        <a href="#hero" className={styles.logo} aria-label="CoSchool — back to top">
          <img src={LOGO_WHITE} alt="CoSchool" width="140" height="26" loading="lazy" />
        </a>

        {/* ── Nav + office ───────────────────────────────── */}
        <div className={styles.navOffice}>
          {/* Navigation links */}
          <nav aria-label="Footer navigation">
            <ul className={styles.navList}>
              {bottomNav.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.isRoute ? link.path : link.externalPath}
                    className={styles.navLink}
                    onClick={(e) => {
                      if (link.isRoute) {
                        e.preventDefault();
                        handleNavigate(link.path, link.isRoute, link.externalPath);
                      }
                    }}
                    target={!link.isRoute ? "_blank" : undefined}
                    rel={!link.isRoute ? "noopener noreferrer" : undefined}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* Office locations */}
          <div className={styles.officeSection}>
            <p className={styles.officeLabel}>Office locations</p>
            <div className={styles.officeItem}>
              <button
                className={styles.officeToggle}
                aria-expanded="true"
                aria-controls="office-address"
              >
                <span className={styles.officeName}>Main Office</span>
                <span className={styles.officeArrow} aria-hidden="true">
                  <img src={ARROW_ICON} alt="" width="24" height="24" loading="lazy" />
                </span>
              </button>
              <address id="office-address" className={styles.officeAddress}>
                3rd floor, QHub SASI ICON, Besides Madhapur Metro Station, Jubilee Hills, Hyderabad - 500033
              </address>
            </div>
          </div>
        </div>

        {/* ── Bottom bar ─────────────────────────────────── */}
        <div className={styles.bottomBar}>
          <div className={styles.legal}>
            <a href={routesLinks.termsandconditions} onClick={(e) => { e.preventDefault(); handleNavigate(routesLinks.termsandconditions, true); }} className={styles.legalLink}>Terms</a>
            <span className={styles.legalSep} aria-hidden="true">•</span>
            <a onClick={() => { handleNavigate(routesLinks.privacypolicy, true) }} className={styles.legalLink} style={{ cursor: 'pointer' }}>Privacy</a>
            <span className={styles.legalSep} aria-hidden="true">•</span>
            <a onClick={() => { window.open("https://www.coschool.ai/feeds", "_blank", "noopener,noreferrer"); }} className={styles.legalLink} style={{ cursor: 'pointer' }}>Feeds</a>
          </div>
          <p className={styles.copyright}>Copyright &copy; Coschool 2026</p>
        </div>
      </div>
    </footer>
  );
}
